PJQ.views.sharing = {};

PJQ.views.sharing.SharingModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Share'),
		subTemplates: {
			contact: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Share-Contact'),
			emailBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Share-Email-Badge')
		},
		isEmailOnly: false,
		canEditSubject: true,
		subject: 'Files have been shared with you',
		preventExpiration: null,
		onSave: null,
		onCancel: null
	},
	events: {
		'click .input-share-link,.btn-share-link-copy': 'copyShareLink',
		'keyup .input-share-search': 'searchChanged',
		'click .share-contact': 'addEmail',
		'click .share-email-delete': 'deleteEmail',
		'change .cb-prevent-expire': 'preventExpiration',
		'click .modal-share-send': 'send',
		'click .modal-share-cancel': 'cancel'
	},
	beforeModalCreated: function () {
		this.selectedEmails = [];
		this.options.preventExpiration = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DRAWING_SHARE_PREVENT_EXPIRATION);
	},
	renderData: function () {
		return {
			options: this.options
		};
	},
	afterRender: function () {
		if (_.size(this.options.url) === 0) {
			this.urlLoader = new PJQ.Loader(this.$('.share-link-outer'), {
				type: 'small'
			});
		}

		if (this.options.project != null) {
			let contactsLoader = new PJQ.Loader(this.$('.share-contacts-outer'));
			this.options.project.fetchProjectContacts(_.bind(function () {
				this.contacts = this.options.project.projectContacts;
				contactsLoader.remove();
				this.searchChanged();
			}, this));
		}
		else {
			this.contacts = new PJQ.collections.contacts.Contacts();
			this.searchChanged();
		}

		this.renderPreventExpire();
	},
	copyShareLink: function () {
		this.$('.input-share-link')[0].select();
		document.execCommand("copy");
		let linkCopiedText = this.$('.text-link-copied');
		linkCopiedText.animateCSS('fadeIn', function () {
			setTimeout(function () {
				linkCopiedText.animateCSS('fadeOut');
			}, 1500);
		});
	},
	urlChanged: function (url) {
		if (_.size(url) > 0 && !this.options.isEmailOnly) {
			this.options.url = url;
			this.$('.input-share-link').val(url);
			this.$('.share-link-outer').removeClass('hidden');
			if (this.urlLoader != null) {
				this.urlLoader.remove();
				this.urlLoader = null;
			}
		}

		this.renderPreventExpire();
	},
	searchChanged: function () {
		let searchText = this.$('.input-share-search').val().toLowerCase(),
			filteredContacts;
		if (_.size(searchText) > 0) {
			filteredContacts = _.filter(this.contacts.models, _.bind(function (contact) {
				let email = contact.get('email').toLowerCase();
				if (_.size(email) === 0 || _.indexOf(this.selectedEmails, email) !== -1) {
					return false;
				}

				return contact.get('contactName').toLowerCase().indexOf(searchText) !== -1 || email.indexOf(searchText) !== -1;
			}, this));
		}
		else {
			filteredContacts = _.filter(this.contacts.models, _.bind(function (contact) {
				let email = contact.get('email').toLowerCase();
				return _.size(email) > 0 && _.indexOf(this.selectedEmails, email) === -1;
			}, this))
		}

		let $addEmail = this.$('.share-add-email'),
			isValidEmail = PJQ.helpers.validators.validateEmail(searchText).success;
		if (isValidEmail && _.size(filteredContacts) === 0) {
			this.$('.share-suggested-contacts').append($('<div>', {
				text: searchText
			}));
			this.$('.share-add-email .share-contact').data('email', searchText);
			this.$('.share-email-entry-letter').html(searchText[0].toUpperCase());
			this.$('.share-email-entry').text(searchText);
			$addEmail.removeClass('hidden');
		}
		else {
			$addEmail.addClass('hidden');
		}

		let $searchResults = this.$('.share-search-results'),
			$searchResultsOuter = this.$('.share-search-results-outer');
		$searchResults.empty();
		if (_.size(filteredContacts) > 0) {
			_.each(_.sortBy(filteredContacts, function (contact) {
				return contact.get('contactName')
			}), _.bind(function (contact) {
				this.renderSubTemplate(true, this.options.subTemplates.contact, $searchResults, {
					model: contact
				});
			}, this));

			$searchResultsOuter.removeClass('hidden');
		}
		else {
			$searchResultsOuter.addClass('hidden');
		}

		let $noResults = this.$('.share-search-no-results');
		if (isValidEmail || _.size(filteredContacts) > 0) {
			$noResults.addClass('hidden');
		}
		else {
			$noResults.removeClass('hidden');
		}
	},
	renderRecipientCount: function () {
		let emailCount = _.size(this.selectedEmails);
		this.$('.recipient-count').html(emailCount.toString() + (emailCount === 1 ? ' recipient' : ' recipients'));
	},
	addEmail: function (e) {
		let email = $(e.currentTarget).closest('.share-contact').data('email');
		this.renderSubTemplate(true, this.options.subTemplates.emailBadge, this.$('.share-selected-emails'), {
			email: email
		});
		this.selectedEmails.push(email.toLowerCase());
		this.$('.input-share-search').val('');
		this.searchChanged();
		this.$('.modal-share-send').prop('disabled', false);
		this.renderRecipientCount();
	},
	deleteEmail: function (e) {
		let emailContainer = $(e.currentTarget).closest('.share-email');
		this.selectedEmails = _.without(this.selectedEmails, emailContainer.data('email').toLowerCase());
		emailContainer.remove();
		this.searchChanged();
		this.$('.modal-share-send').prop('disabled', _.size(this.selectedEmails) === 0);
		this.renderRecipientCount();
	},
	send: function () {
		if (typeof this.options.onSave === 'function') {
			this.options.onSave({
				emails: this.selectedEmails,
				subject: this.options.canEditSubject ? this.$('.input-share-subject').val() : null
			});
		}
	},
	cancel: function () {
		if (typeof this.options.onCancel === 'function') {
			this.options.onCancel();
		}
	},
	preventExpiration: function () {
		this.options.preventExpiration = this.$('.cb-prevent-expire').prop('checked');

		if (this.options.preventExpiration) {
			PJQ.notifications.createNotifyModal({
				header: 'Prevent Drawing Link Expiration',
				notification: "You have selected for this share link to prevent expiration.  <b>With this selected, all drawings in the selected versions will be included in this share</b> and any individual drawing selections you made will be removed.",
				cookie: PJQ.constants.cookies.NOTIFY_DRAWING_SHARE_PREVENT_EXPIRE,
			});
		}

		if (this.collection != null) {
			this.collection.options.allDrawings = this.options.preventExpiration;
			this.collection.update();
		}

		this.renderPreventExpire();
	},
	renderPreventExpire: function () {
		if (this.collection != null && _.size(this.collection.options.versionIds) > 0) {
			this.$('.prevent-expire-outer').removeClass('hidden');
			this.$('.prevent-expire').prop('checked', this.options.preventExpiration);
		}

		if (this.options.preventExpiration) {
			this.$preventExpireAlert = new PJQ.Alert(this.$('.alert-header'), {
				text: 'You have selected for this link to prevent expiration.  With this selected, only full versions can be shared.  When drawings in the shared versions change, this link will be updated with the changes.'
			});
		}
		else {
			if (this.$preventExpireAlert != null) {
				this.$preventExpireAlert.destroy();
				this.$preventExpireAlert = null;
			}
		}
	}
});